var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "chatViewComponent" } },
    [
      _c(
        "AppBreadCrumb",
        {
          key: Math.random(),
          attrs: {
            paths: [{ title: "Chat", path: "chat" }],
            select: !!_vm.activeConversation || ![1, 4].includes(_vm.tabIndex),
            "show-subjects": true,
            "show-trial-remain-day": true,
          },
          on: { "to-chat-main": _vm.toMainMenu },
        },
        [
          _vm.tabIndex === 0 && !_vm.activeConversation
            ? _c("div", { staticClass: "chatListSettingContainer" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: { followCursor: true, placement: "bottom-end" },
                        expression:
                          "{ followCursor: true, placement: 'bottom-end' }",
                      },
                    ],
                    staticClass: "custom-checkbox2",
                    staticStyle: { "max-width": "120px", width: "120px" },
                    attrs: { content: _vm.$t("message.showMyChats") },
                  },
                  [
                    _c(
                      "a-switch",
                      {
                        attrs: { size: "small" },
                        model: {
                          value: _vm.showMyChats,
                          callback: function ($$v) {
                            _vm.showMyChats = $$v
                          },
                          expression: "showMyChats",
                        },
                      },
                      [
                        _c("a-icon", {
                          attrs: { slot: "checkedChildren", type: "check" },
                          slot: "checkedChildren",
                        }),
                        _vm._v(" "),
                        _c("a-icon", {
                          attrs: { slot: "unCheckedChildren", type: "close" },
                          slot: "unCheckedChildren",
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.$t("message.showMyChats")))]),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.showMyChats
                  ? _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              followCursor: true,
                              placement: "bottom-end",
                            },
                            expression:
                              "{ followCursor: true, placement: 'bottom-end' }",
                          },
                        ],
                        staticClass: "custom-checkbox2",
                        attrs: { content: _vm.$t("message.showWaitingChats") },
                      },
                      [
                        _c(
                          "a-switch",
                          {
                            attrs: { size: "small" },
                            model: {
                              value: _vm.showUnassignedChats,
                              callback: function ($$v) {
                                _vm.showUnassignedChats = $$v
                              },
                              expression: "showUnassignedChats",
                            },
                          },
                          [
                            _c("a-icon", {
                              attrs: { slot: "checkedChildren", type: "check" },
                              slot: "checkedChildren",
                            }),
                            _vm._v(" "),
                            _c("a-icon", {
                              attrs: {
                                slot: "unCheckedChildren",
                                type: "close",
                              },
                              slot: "unCheckedChildren",
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("message.showWaitingChats"))),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.tabIndex === 2 && !_vm.activeConversation
            ? _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.timeSelect,
                      expression: "timeSelect",
                    },
                  ],
                  attrs: { id: "time-select" },
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.timeSelect = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                [
                  _c("option", { attrs: { value: "today" } }, [
                    _vm._v(_vm._s(_vm.$t("time.today"))),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "yesterday" } }, [
                    _vm._v(_vm._s(_vm.$t("time.yesterday"))),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "current-week" } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("time.currentWeek")) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "last-week" } }, [
                    _vm._v(_vm._s(_vm.$t("time.lastWeek"))),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "current-month" } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("time.currentMonth")) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "last-month" } }, [
                    _vm._v(_vm._s(_vm.$t("time.lastMonth"))),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "last-30" } }, [
                    _vm._v(_vm._s(_vm.$t("time.last30Day"))),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "all-time" } }, [
                    _vm._v(_vm._s(_vm.$t("time.allTime"))),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.tabIndex === 3 && !_vm.activeConversation
            ? _c("div", { staticClass: "chatListSettingContainer" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: { followCursor: true, placement: "bottom-end" },
                        expression:
                          "{ followCursor: true, placement: 'bottom-end' }",
                      },
                    ],
                    staticClass: "custom-checkbox2",
                    attrs: { content: _vm.$t("message.showOnlineAgents") },
                  },
                  [
                    _c(
                      "a-switch",
                      {
                        attrs: { size: "small" },
                        model: {
                          value: _vm.showOnlineAgents,
                          callback: function ($$v) {
                            _vm.showOnlineAgents = $$v
                          },
                          expression: "showOnlineAgents",
                        },
                      },
                      [
                        _c("a-icon", {
                          attrs: { slot: "checkedChildren", type: "check" },
                          slot: "checkedChildren",
                        }),
                        _vm._v(" "),
                        _c("a-icon", {
                          attrs: { slot: "unCheckedChildren", type: "close" },
                          slot: "unCheckedChildren",
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("message.showOnlineAgents"))),
                    ]),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.activeConversation
            ? _c(
                "button",
                {
                  staticClass: "actionButtonBreadcrumb",
                  on: {
                    click: function ($event) {
                      return _vm.toggleChatHistory(true)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("message.prevChats")) +
                      "\n        "
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "position-relative pt-3",
          staticStyle: { padding: "0 15px" },
          attrs: { id: "chat" },
        },
        [
          _c(
            "b-alert",
            {
              staticClass: "rounded-0",
              attrs: {
                show: _vm.socketConnecting && _vm.user != null,
                variant: "info",
              },
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("message.socketConnecting")) +
                  "\n        "
              ),
            ]
          ),
          _vm._v(" "),
          _vm.activeConversation ? _c("ChatWindow") : _vm._e(),
          _vm._v(" "),
          !_vm.activeConversation
            ? _c(
                "a-row",
                { staticStyle: { padding: "0 15px" } },
                [
                  _c(
                    "a-tabs",
                    {
                      attrs: {
                        size: "small",
                        animated: false,
                        "tab-position": _vm.position,
                        tabBarGutter: 10,
                      },
                      model: {
                        value: _vm.tabIndex,
                        callback: function ($$v) {
                          _vm.tabIndex = $$v
                        },
                        expression: "tabIndex",
                      },
                    },
                    [
                      !_vm.isAdmin
                        ? _c(
                            "a-tab-pane",
                            {
                              key: 0,
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "tab",
                                    fn: function () {
                                      return [
                                        _c("span", { staticClass: "tt-item" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("message.liveSupport")
                                            ) +
                                              " (" +
                                              _vm._s(_vm.stats.total) +
                                              ")"
                                          ),
                                        ]),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                786877061
                              ),
                            },
                            [
                              _vm._v(" "),
                              _vm.tabIndex === 0
                                ? _c("ChatList", {
                                    attrs: {
                                      position: _vm.position,
                                      showMyChats: _vm.showMyChats,
                                      showUnassignedChats:
                                        _vm.showUnassignedChats,
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isAdmin && _vm.visitorViewPermissionExits
                        ? _c(
                            "a-tab-pane",
                            {
                              key: 1,
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "tab",
                                    fn: function () {
                                      return [
                                        _c("span", { staticClass: "tt-item" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("message.siteVisitors")
                                            ) +
                                              " (" +
                                              _vm._s(_vm.liveVisitorCount) +
                                              ")"
                                          ),
                                        ]),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                1372934140
                              ),
                            },
                            [
                              _vm._v(" "),
                              _vm.tabIndex === 1 ? _c("VisitorList") : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "a-tab-pane",
                        {
                          key: 2,
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "tab",
                                fn: function () {
                                  return [
                                    _c("span", { staticClass: "tt-item" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("message.conversationHistory")
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            2836661433
                          ),
                        },
                        [
                          _vm._v(" "),
                          _vm.tabIndex === 2
                            ? _c("VisitorHistory", {
                                attrs: { "time-select": _vm.timeSelect },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.isAdmin
                        ? _c(
                            "a-tab-pane",
                            {
                              key: 3,
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "tab",
                                    fn: function () {
                                      return [
                                        _c("span", { staticClass: "tt-item" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("message.representative")
                                            )
                                          ),
                                        ]),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                2800594789
                              ),
                            },
                            [
                              _vm._v(" "),
                              _vm.tabIndex === 3
                                ? _c("AgentList", {
                                    attrs: {
                                      assign: false,
                                      "info-button-visible": true,
                                      reportButton: true,
                                      showOnlineAgents: _vm.showOnlineAgents,
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isAdmin
                        ? _c(
                            "a-tab-pane",
                            {
                              key: 4,
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "tab",
                                    fn: function () {
                                      return [
                                        _c("span", { staticClass: "tt-item" }, [
                                          _vm._v(
                                            "Chat Bot (" +
                                              _vm._s(_vm.stats.chatbot || 0) +
                                              ")"
                                          ),
                                        ]),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                197334652
                              ),
                            },
                            [
                              _vm._v(" "),
                              _vm.tabIndex === 5 ? _c("BotChatList") : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isAdmin && _vm.whatsappEnabled
                        ? _c(
                            "a-tab-pane",
                            {
                              key: 5,
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "tab",
                                    fn: function () {
                                      return [
                                        _c("span", { staticClass: "tt-item" }, [
                                          _vm._v("Whatsapp Contacts"),
                                        ]),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                1487967972
                              ),
                            },
                            [
                              _vm._v(" "),
                              _vm.tabIndex === 5
                                ? _c("WhatsappContactList")
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-row",
        {
          staticStyle: { position: "fixed", bottom: "10px", "z-index": "999" },
          attrs: { id: "chatBarContainer" },
        },
        [
          _c("ChatBar", {
            attrs: { "return-ref": _vm.getRef, visible: !_vm.isAdmin },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "private-message-form",
            title: _vm.$t("message.privateMessage"),
            "hide-footer": "",
          },
          on: { hidden: _vm.resetPM },
        },
        [_c("PrivateMessage")],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "assign-agent",
            title: _vm.$t("message.addRepresentative"),
            centered: "",
            "hide-footer": "",
            size: "xl",
          },
        },
        [
          _c("AgentList", {
            attrs: { assign: true, "show-online-agents": true },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "forward-agent",
            title: _vm.$t("message.forwardRepresentative"),
            centered: "",
            "hide-footer": "",
            size: "xl",
          },
        },
        [
          _c("AgentList", {
            attrs: { forward: true, "show-online-agents": true },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }